export default __webpack_public_path__ + "static/media/renovation-2.47d42983.jpg";